import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from './components/Footer';
import Header from './components/Header';
import StaffList from './components/StaffList';
import StaffPresentation from './components/StaffPresentation';

function Staff() {
  const state = {
    activeTab: {
      home: '',
      aboutUs: '',
      staff: 'active',
      apply: '',
    },
    linkWebsite: '/staff',
  };

  return (
    <>
      <Helmet>
        <title>Nossa Equipe - Alliance Virtual</title>
      </Helmet>
      <Header activeTab={state.activeTab} linkWebsite={state.linkWebsite} />
      <StaffPresentation />
      <StaffList />
      <Footer />
    </>
  );
}

export default Staff;
